import { inheritsLoose as _inheritsLoose, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized } from '../_virtual/_rollupPluginBabelHelpers.js';
import { position } from '@emoney/kyber-helpers';
import { cloneElement, PureComponent } from 'react';
import { findDOMNode } from 'react-dom';

var Position = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(Position, _PureComponent);

  function Position() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "_position", null);

    _defineProperty(_assertThisInitialized(_this), "_target", null);

    return _this;
  }

  var _proto = Position.prototype;

  _proto.updatePosition = function updatePosition(placement, flip) {
    if (placement === void 0) {
      placement = this.props.placement;
    }

    if (flip === void 0) {
      flip = this.props.flip;
    }

    var positionTo = findDOMNode(this.props.positionTo());
    this.clearPosition();
    this._position = position(positionTo, this._target, placement, typeof this.props.offset === 'function' ? this.props.offset() : this.props.offset, this.props.arrow, flip);
    this._position && this._position.update();
  };

  _proto.clearPosition = function clearPosition() {
    if (this._position) {
      this._position.destroy();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.updatePosition();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var placementChanged = prevProps.placement !== this.props.placement;
    var flipChanged = prevProps.flip !== this.props.flip;
    var offsetChanged = prevProps.offset !== this.props.offset;

    if (placementChanged || flipChanged || offsetChanged || !this._target || !this._position) {
      this.updatePosition();
      return;
    }

    this._position && this._position.update();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.clearPosition();
  };

  _proto.render = function render() {
    var _this2 = this;

    return typeof this.props.children === 'function' ? this.props.children(this._target) : /*#__PURE__*/cloneElement(this.props.children, {
      ref: function ref(node) {
        _this2._target = findDOMNode(node); // call any existing ref functions

        var ref = _this2.props.children.ref;

        if (typeof ref === 'function') {
          ref(node);
        }
      }
    });
  };

  return Position;
}(PureComponent);

Position.defaultProps = {
  placement: 'bottom-start',
  flip: false
};
Position.displayName = 'Position';

export default Position;
